import type {
  GroupMeetingSyncSchedulesResult,
  GroupMeetingSyncSchedulesResultDto,
  GroupMeetingSyncSchedulesRow,
  GroupMeetingSyncSchedulesRowDto,
} from "meetings/group-meeting/types";

const rowFromDto = (
  dto: GroupMeetingSyncSchedulesRowDto,
): GroupMeetingSyncSchedulesRow => ({
  teacherShortage: dto.teacher_shortage,
  mentorClass: dto.mentor_class,
  currentTotal: dto.current_total,
  newTotal: dto.new_total,
  added: dto.added,
  removed: dto.removed,
  skipped: dto.skipped,
});

export const groupMeetingSyncSchedulesFromDto = (
  dto: GroupMeetingSyncSchedulesResultDto,
): GroupMeetingSyncSchedulesResult => {
  const rows = dto.results.map(rowFromDto);

  return {
    rows,
    timestamp: dto.timestamp,
    hasChanges: rows.some((row) => row.added > 0 || row.removed > 0),
  };
};
